const ADMIN_TIME_OFFSET_KEY = "pfConsole.timeOffsetMinutes";

export const getAdminTimeOffsetMinutes = () => {
  if (typeof window === "undefined") return 0;

  const rawValue = window.localStorage.getItem(ADMIN_TIME_OFFSET_KEY);
  if (!rawValue) return 0;

  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) return 0;

  return Math.round(parsed);
};

export const setAdminTimeOffsetMinutes = (offsetMinutes: number) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(ADMIN_TIME_OFFSET_KEY, String(Math.round(offsetMinutes)));
};

export const formatLocalDateTime = (value?: string) => {
  if (!value) return "-";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";

  const offsetMinutes = getAdminTimeOffsetMinutes();
  const adjusted = new Date(parsed.getTime() + offsetMinutes * 60_000);

  return adjusted.toLocaleString();
};
